import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'// svg component

// register globally
Vue.component('svg-icon', SvgIcon)


const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
const  iconMap =requireAll(req)
console.log("***iconMap**")
console.log(iconMap)




// WEBPACK FOOTER //
// ./src/icons/index.js